import React from "react";

import PropTypes from "prop-types";
import { createGlobalStyle } from "styled-components";

const fontWeightMap = {
  bold: 700,
  medium: 500,
  regular: 400,
};

const getFontFormat = (ext) => {
  switch (ext) {
    case ".ttf":
      return "truetype";
    case ".otf":
      return "opentype";
    case ".woff":
      return "woff";
    case ".woff2":
      return "woff2";
    case ".eot":
      return "embedded-opentype";
    case ".svg":
      return "svg";
    default:
      return null;
  }
};

const FontFace = createGlobalStyle`
  @font-face {
    font-family: ${({ font }) => font.fontFamily};
    src: url("${({ font }) => font.fontFile?.url || ""}")
         ${({ font }) => {
           const format = getFontFormat(font.fontFile?.ext);
           return format ? `format("${format}")` : "";
         }};
    font-weight: ${({ font }) => fontWeightMap[font.fontWeight]};
    font-display: swap;
  }

  .${({ font }) => font.fontName?.toLowerCase()?.replace(/\s/g, "-")} {
      font-family: ${({ font }) => font.fontFamily};
  }
`;

const DefaultFont = createGlobalStyle`
  body {
    font-family: ${({ defaultFont }) => defaultFont};
  }
`;

const HeaderFont = createGlobalStyle`
  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ headerFont }) => headerFont};
  }
`;

const BodyBackgroundColor = createGlobalStyle`
  body {
    background-color: ${({ backgroundColor }) =>
      `${backgroundColor || "#fff"}`};
  }
`;

const GlobalStyle = createGlobalStyle`
  body{
    a {
      -webkit-appearance: none !important;
    }
  }
`;

function GlobalCSS(props) {
  const { fonts, defaultFont, headerFont, backgroundColor } = props;

  return (
    <>
      <GlobalStyle />
      {fonts?.length > 0 &&
        fonts.map(({ fontName, ...restFields }) => (
          <FontFace key={fontName} font={{ fontName, ...restFields }} />
        ))}
      {defaultFont && <DefaultFont defaultFont={defaultFont} />}
      {headerFont && <HeaderFont headerFont={headerFont} />}
      {backgroundColor && (
        <BodyBackgroundColor backgroundColor={backgroundColor} />
      )}
    </>
  );
}
export default GlobalCSS;
GlobalCSS.propTypes = {
  backgroundColor: PropTypes.string,
  defaultFont: PropTypes.string,
  headerFont: PropTypes.string,
  fonts: PropTypes.arrayOf(
    PropTypes.shape({
      attributes: PropTypes.shape({
        fontFamily: PropTypes.string.isRequired,
        fontFile: PropTypes.shape({
          data: PropTypes.shape({
            attributes: PropTypes.shape({
              url: PropTypes.string.isRequired,
              ext: PropTypes.string,
            }),
          }),
        }).isRequired,
        fontName: PropTypes.string.isRequired,
        fontWeight: PropTypes.oneOf(["bold", "medium", "regular"]).isRequired,
        isHeaderFont: PropTypes.bool,
      }),
    })
  ).isRequired,
};

GlobalCSS.defaultProps = {
  backgroundColor: null,
  defaultFont: null,
  headerFont: null,
};
